import Markdown from "react-markdown";
import { useSearchParams } from "react-router-dom";
import PROFILES from "../data/profiles";
import heartMascot from "../assets/images/heart_mascot.svg";
import arrows from "../assets/images/arrows.svg";
import t from "../locales";
import Header from "../components/header";
import Footer from "../components/footer";

export default function SharedResultPage() {
  const decodeBase64 = atob;
  const [searchParams] = useSearchParams();

  const getAnswers = (param) => {
    try {
      const decoded = JSON.parse(decodeBase64(param));
      const { action_habits, action_environment, action_devices, profile } =
        decoded;
      const { devices, habits, environment } = PROFILES[profile];
      return {
        action_habits,
        action_environment,
        action_devices,
        profile,
        devices,
        habits,
        environment,
      };
    } catch {
      // We ignore any errors when decoding, but return an empty object
      return {};
    }
  };

  const answers = getAnswers(searchParams.get("p"));

  let canRender = Object.entries(answers).length > 0;

  if (!canRender) return <div></div>; // We display an empty page if params are tampered with

  const {
    action_habits,
    action_environment,
    action_devices,
    devices,
    habits,
    environment,
  } = answers;

  return (
    <>
      <title>{t("share.page.title")}</title>
      <div className="page">
        <Header />
        <div className="share">
          <div className="share__boxes-container">
            <div className="share__banner-container">
              <div className="share__banner">
                <img className="share__image" src={heartMascot} alt="" />
                <h2 className="share__banner-text">
                  {t("share.banner.title")}
                </h2>
              </div>
              <img className="share__arrows --show-lg" src={arrows} alt="" />
            </div>
            <div className="share__boxes">
              <div className="share__box">
                <div className="share__box-header">
                  <Markdown>{t("share.banner.habits")}</Markdown>
                </div>
                <div className="share__box-text">
                  <Markdown>{habits.choices[action_habits]}</Markdown>
                </div>
              </div>
              <div className="share__box">
                <div className="share__box-header">
                  <Markdown>{t("share.banner.environment")}</Markdown>
                </div>
                <div className="share__box-text">
                  <Markdown>{environment.choices[action_environment]}</Markdown>
                </div>
              </div>
              <div className="share__box">
                <div className="share__box-header">
                  <Markdown>{t("share.banner.devices")}</Markdown>
                </div>
                <div className="share__box-text">
                  <Markdown>{devices.choices[action_devices]}</Markdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
